// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"FAQPop_ConfirmationPop__MOvmE","modalBody":"FAQPop_modalBody__INRlX"};